<template>
  <div>
    <div class="bill-card__title">
      Mensalidade de {{ bill.month_name }}
      <span v-if="reenrollmentBill">(Rematrícula)</span>
    </div>

    <div class="bill-card__bill-status">
      <div class="bill-card__bill-status-title">
        Pagamento em aberto
      </div>
    </div>

    <div class="bill-card__data">
      <div class="bill-card__data-item">
        <strong>Mensalidade:</strong>
        <span class="bill-card__data-item__value">
          {{ bill.full_value | formatCurrency }}
        </span>
      </div>

      <div class="bill-card__data-divider"></div>

      <div class="bill-card__data-item">
        <template v-if="isCreditCard">
          <strong>Data da cobrança:</strong>
          <span class="bill-card__data-item__value">
            {{ dueDate }}
          </span>
        </template>

        <template v-else>
          <strong>Vencimento:</strong>
          <span class="bill-card__data-item__value">
            {{ dueDate }}
          </span>
        </template>
      </div>

      <div class="bill-card__data-divider"></div>

      <div class="bill-card__data-item">
        <strong>Pagamento:</strong>
        <span class="bill-card__data-item__value">
          <template v-if="isCreditCard">
            <span class="bill-card__card-brand">
              {{ creditCard.card_brand }}
            </span>
            final {{ creditCard.last_digits }}
          </template>
          <template v-else-if="isPix">
            Pix
          </template>
          <template v-else>
            Boleto
          </template>
        </span>
      </div>
    </div>

    <router-link
      tag="button"
      :to="{ name: 'bill-credit-card', params: { billId: bill.id } }"
      class="z-button z-button--primary z-button--block"
      v-if="isCreditCard"
    >
      Ver Detalhes
    </router-link>

    <router-link
      tag="button"
      :to="{ name: 'nb-pix', params: { billId: bill.id } }"
      class="z-button z-button--primary z-button--block"
      v-else-if="isPix"
    >
      Gerar Pix
    </router-link>

    <router-link
      tag="button"
      :to="{ name: 'bill-boleto', params: { billId: bill.id } }"
      class="z-button z-button--primary z-button--block"
      v-else
    >
      Gerar Boleto
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
@import '@quero/zilla-core/src/atoms/z-caption';

.bill-card__title {
  @extend .z-caption;
  margin-bottom: var(--space-small);
  text-align: center;
}

.bill-card__bill-status {
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--space-large);
  text-align: center;
}

.bill-card__bill-status-title {
  font-size: rem(19);
  line-height: rem(23);
  margin-bottom: var(--space-large);
}

.bill-card__data {
  margin-bottom: var(--space-large);

  @media (min-width: $screen-md-min) {
    display: flex;
    justify-content: space-around;
    margin-bottom: var(--space-jumbo);
  }
}

.bill-card__data-item {
  color: var(--color-neutral-dark-gray);
  font-size: rem(16);
  line-height: rem(24);
  margin-bottom: var(--space-extra-small);
}

.bill-card__data-item__value {
  @media (min-width: $screen-md-min) {
    display: block;
  }
}

.bill-card__card-brand {
  text-transform: capitalize;
}

.bill-card__data-divider {
  background-color: var(--color-neutral-lighter-gray);
  display: none;
  width: 2px;

  @media (min-width: $screen-md-min) {
    display: block;
  }
}
</style>

<script>
import DateUtils from 'utils/date-utils';

export default {
  props: {
    bill: {
      type: Object,
      default: () => ({}),
    },
    paymentMethod: {
      type: String,
      default: 'boleto',
    },
    creditCard: {
      type: Object,
      default: (() => {}),
    },
  },
  computed: {
    dueDate() {
      return DateUtils.getFormattedDate(this.bill.due_date);
    },
    isCreditCard() {
      return this.paymentMethod === 'credit_card';
    },
    isPix() {
      return this.paymentMethod === 'pix';
    },
    reenrollmentBill() {
      return this.bill.metadata?.reenrollment_id;
    },
  },
};
</script>
